"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedList = void 0;
class PaginatedList {
    constructor(items, skip, limit, totalCount) {
        this.totalCount = 0;
        this.items = items;
        this.limit = limit;
        this.skip = skip;
        this.totalCount = totalCount;
    }
}
exports.PaginatedList = PaginatedList;
//# sourceMappingURL=PaginatedList.js.map